"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchChallenges = exports.createRoom = exports.fetchRooms = undefined;

var _requests = require("../libs/utils/requests");

var _RoomsActionTypes = require("../constants/action-types/RoomsActionTypes");

var types = _interopRequireWildcard(_RoomsActionTypes);

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var loadingRequest = function loadingRequest() {
  return {
    type: types.LOADING_REQUEST
  };
};

var fetchRoomsSuccess = function fetchRoomsSuccess(_ref) {
  var rooms = _ref.rooms;
  return {
    type: types.FETCH_ROOMS_SUCCESS,
    payload: {
      list: rooms
    }
  };
};

var fetchRoomsFailure = function fetchRoomsFailure(_ref2) {
  var error = _ref2.error;
  return {
    type: types.FETCH_ROOMS_FAILURE,
    payload: {
      error: error
    }
  };
};

var fetchRooms = exports.fetchRooms = function fetchRooms() {
  var fetchOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    }
  };
  var destination = _config2.default.serviceUrls.api.rooms;
  return function (dispatch) {
    dispatch(loadingRequest());
    (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions
    }).then(function (response) {
      dispatch(fetchRoomsSuccess(response.payload));
    }).catch(function (error) {
      dispatch(fetchRoomsFailure({
        error: error
      }));
    });
  };
};

var createRoomFailure = function createRoomFailure(_ref3) {
  var error = _ref3.error;
  return {
    type: types.CREATE_ROOM_FAILURE,
    payload: {
      error: error
    }
  };
};

var createRoom = exports.createRoom = function createRoom(_ref4) {
  var challengeName = _ref4.challengeName,
      playerNames = _ref4.playerNames;
  var fetchOptions = {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      challengeName: challengeName,
      playerNames: playerNames
    }),
    headers: {
      "Content-Type": "application/json"
    }
  };
  var destination = _config2.default.serviceUrls.api.rooms;
  return function (dispatch) {
    dispatch(loadingRequest());
    (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions
    }).then(function () {
      dispatch(fetchRooms());
    }).catch(function (error) {
      dispatch(createRoomFailure({
        error: error
      }));
    });
  };
};

var fetchChallengesSuccess = function fetchChallengesSuccess(_ref5) {
  var challenges = _ref5.challenges;
  return {
    type: types.FETCH_CHALLENGES_SUCCESS,
    payload: {
      challenges: challenges
    }
  };
};

var fetchChallengesFailure = function fetchChallengesFailure(_ref6) {
  var error = _ref6.error;
  return {
    type: types.FETCH_CHALLENGES_FAILURE,
    payload: {
      error: error
    }
  };
};

var fetchChallenges = exports.fetchChallenges = function fetchChallenges() {
  var fetchOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  };
  var destination = _config2.default.serviceUrls.api.challenges;
  return function (dispatch) {
    dispatch(loadingRequest());
    (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions
    }).then(function (response) {
      dispatch(fetchChallengesSuccess(response.payload));
    }).catch(function (error) {
      dispatch(fetchChallengesFailure(error));
    });
  };
};